import React, { Fragment, useEffect, useState } from "react";
import { Form, Input, Button, Space, Skeleton } from "antd";
import { connect, useDispatch, useSelector } from "react-redux";
import { postData } from "../../../Actions/Action";
import { getFDOCouponCarrierInfo } from "../../../Actions/FDOActions";
import types from "../../../Stores/types";

function ConnectionSettingsComponent(props) {
  const [connectionState, setConnectionState] = useState({
    testType: false,
    skeleton_loading: true,
  });
  const { fdoCouponInfo, fdoCouponCarrierInfo, token, connectionSettings, isInstalling } =
    useSelector((state) => state);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getFDOCouponCarrierInfo(
        token,
        "small-package",
        fdoCouponInfo ? fdoCouponInfo?.code ?? "" : ""
      )
    );
  }, [dispatch, token, fdoCouponInfo]);

  useEffect(() => {
    if (connectionSettings) {
      dispatch({
        type: types.SET_WWE_SMALL_API_TYPE,
        payload: "new_api",
      });
    }
  }, [connectionSettings, dispatch]);

  const handleTypeChange = (type) => {
    setConnectionState({ ...connectionState, testType: type });
  };

  const onFinish = (values) => {
    values = {
      ...connectionSettings,
      ...values,
      api_type: "new_api",
    };
    values.testType = connectionState.testType;
    values.installed_carrier_id = props.carrierId;
    values.carrierId = props.carrierId;

    if (fdoCouponCarrierInfo)
      values.is_enabled = fdoCouponCarrierInfo.is_enabled ?? false;

    props.postData(values, props.token);
  };

  if (
    props.connectionSettings === null ||
    props.connectionSettings === undefined
  ) {
    return <Skeleton active />;
  }

  return (
    <Fragment>
      <div className={"note-bx"}>
        <strong>Note!</strong> You must have a Worldwide Express account to use
        this application. If you do not have one, click{" "}
        <a
          href="https://wwex.com/our-technology/e-commerce-solutions"
          target="_blank"
          rel="noreferrer"
        >
          here
        </a>{" "}
        to access presenter account request form.
      </div>

      <Form
        layout="vertical"
        name="connection_settings"
        className="connection-settings"
        size={"large"}
        initialValues={props.connectionSettings}
        onFinish={onFinish}
      >
        <Form.Item
          className="mb-1"
          label="Nickname"
          name="nickname"
          required={true}
          rules={[{ required: !connectionState.testType, message: "Nickname is required" }]}
        >
          <Input placeholder="e.g., WWE Small" />
        </Form.Item>
        <Form.Item
          label="Client ID"
          name="clientId"
          required={true}
          rules={[{ required: connectionState.testType, message: "Client ID is required" }]}
        >
          <Input placeholder="Client ID" maxLength={100} />
        </Form.Item>
        <Form.Item
          className="mb-1"
          label="Client Secret"
          name="clientSecret"
          required={true}
          rules={[{ required: connectionState.testType, message: "Client Secret is required" }]}
        >
          <Input placeholder="Client Secret" maxLength={100} />
        </Form.Item>
        <div>
          <a
            href="https://eniture.com/bigcommerce-worldwide-express-api-connection-instructions/"
            target="_blank"
            rel="noreferrer"
          >
            How to obtain your Worldwide Express Client ID and Client Secret?
          </a>
        </div>
        <Form.Item
          className="mt-1"
          label="Username"
          name="new_api_username"
          rules={[{ required: false, message: "Username is required" }]}
        >
          <Input placeholder="Username" />
        </Form.Item>
        <Form.Item
          label="Password"
          name="new_api_password"
          rules={[{ required: false, message: "Password is required" }]}
        >
          <Input type="text" placeholder="Password" />
        </Form.Item>

        <Form.Item style={{ textAlign: "right", marginBottom: "0" }}>
          <Space>
            <Button
              type="primary"
              size={"large"}
              htmlType="submit"
              name={`test`}
              onClick={() => handleTypeChange(true)}
            >
              Test Connection
            </Button>
            <Button
              type="primary"
              size={"large"}
              htmlType="submit"
              name={`save`}
              onClick={() => handleTypeChange(false)}
            >
              Save Settings
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    connectionSettings: state.connectionSettings,
    skeleton_loading: state.skeleton_loading,
    token: state.token,
    carrierId: state.carrierId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    postData: (data, token) =>
      dispatch(
        postData(
          data,
          "GET_CONNECTION_SETTINGS",
          "submit_connection_settings",
          token
        )
      ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectionSettingsComponent);
